<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import Message from 'primevue/message'

export type MessageColor = 'success' | 'info' | 'warning' | 'danger'
export type MessageVariant = 'filled' | 'outlined' | 'simple'
export type MessageSize = 'small' | 'normal' | 'large'

interface Props {
  /** Inline content fallback when no default slot is provided. */
  message?: string
  /** Semantic color — uses the kit's standard color names. */
  color?: MessageColor
  size?: MessageSize
  variant?: MessageVariant
  closable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  color: 'info',
  size: 'small',
  variant: 'simple',
  closable: false,
})

const attrs = useAttrs()

// PrimeVue's Message uses `warn` and `error` for severity; map our color names.
const primeSeverity = computed(() => {
  if (props.color === 'warning') return 'warn'
  if (props.color === 'danger') return 'error'
  return props.color
})
</script>

<template>
  <Message
    v-bind="attrs"
    :severity="primeSeverity"
    :size="props.size"
    :variant="props.variant"
    :closable="props.closable"
  >
    <slot>
      {{ props.message }}
    </slot>
  </Message>
</template>
